import { Creds } from './creds';

const OAUTH_CLIENT_ID = '617199861077-prdf3a2qa1bh8b8ccnipcm8ck3h0fa6a.apps.googleusercontent.com';
const GIS_JS = 'https://accounts.google.com/gsi/client';

let google;

export interface GoogleSigninOptions {
  uxMode?: 'popup' | 'redirect';
}

const DEFAULT_OPTIONS: GoogleSigninOptions = {
  uxMode: 'popup',
};


/**
 * Class that handles Google identity. Replaces GoogleAuthenticator.
 */
export class GoogleIdentityService {
  private areScriptsLoaded: boolean = false;
  private isBooted: boolean = false;
  private creds: Creds = null;
  private options: GoogleSigninOptions;

  private containerEl: HTMLElement;

  constructor(divForButton: HTMLDivElement, options: GoogleSigninOptions = DEFAULT_OPTIONS) {
    this.containerEl = divForButton;
    this.options = options;
  }

  async boot() {
    let gisLoadedPromise: Promise<boolean>;

    if (typeof window['google'] === 'undefined') {
      gisLoadedPromise = new Promise((resolve, reject) => {
        // If we cannot load the Google API script, then die.
        const gScript = document.createElement('script');
        gScript.setAttribute('async', 'async');
        gScript.setAttribute('defer', 'defer');
        gScript.onerror = err => reject(err);
        gScript.addEventListener('load', () => resolve(true));
        gScript.setAttribute('src', GIS_JS);
        document.body.appendChild(gScript);
      });
    } else {
      gisLoadedPromise = Promise.resolve(true);
    }

    try {
      this.areScriptsLoaded = await gisLoadedPromise;
      if (this.areScriptsLoaded) {
        google = window['google'];

        const gisInitializedPromise: Promise<Creds> = new Promise((resolve, reject) => {
          try {
            google.accounts.id.initialize({
              auto_select: true,
              callback: (response) => {
                resolve({
                  id_token: response.credential,
                  access_token: undefined,
                  session_token: undefined,
                  user_id: undefined,
                });
              },
              client_id: OAUTH_CLIENT_ID,
              nonce: getNonce(),
              ux_mode: this.options.uxMode,
            });
            google.accounts.id.prompt((notification) => {
              if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                if (notification.isNotDisplayed()) console.log('Google ID prompt not shown');
                if (notification.isSkippedMoment()) console.log('Google ID prompt skipped');
                google.accounts.id.renderButton(this.containerEl, {});
              }
            });
          } catch (err) {
            reject(err);
          }
        });

        this.creds = await gisInitializedPromise;
        this.isBooted = true;
      } else {
        throw `Somehow, the scripts did not load successfully`;
      }
    } catch (err) {
      throw `Was not booted properly: ${err}`;
    }
  }

  /**
   * Authenticates the user or waits for them to sign in (by rendering a signin button).
   */
  async authenticateOrWaitForSignIn(): Promise<Creds> {
    if (!this.isBooted) {
      await this.boot();
    }
    return Promise.resolve(this.creds);
  }

  /**
   * Reloads the authentication response from Google.
   * @deprecated
   */
  refresh(): Promise<Creds> {
    return new Promise((resolve, reject) => {
      google.accounts.id.initialize({
        auto_select: true,
        callback: (response) => {
          debugger;
          this.creds = {
            id_token: response.credential,
            access_token: undefined,
            session_token: undefined,
            user_id: undefined,
          };
          resolve(this.creds);
        },
        client_id: OAUTH_CLIENT_ID,
        nonce: getNonce(),
        ux_mode: this.options.uxMode,
      });
    });
  }
}

const NONCE_CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function getNonce(): string {
  let nonce = '';
  for (let i = 0; i < 10; ++i) {
    nonce += NONCE_CHARS[Math.floor(Math.random() * NONCE_CHARS.length)];
  }
  console.log(`nonce is: ${nonce}`);
  return nonce;
}
